import { Component, Input } from '@angular/core';
import type { ActivitySummaryCategory } from '../../utils/activity-summary.utils';

@Component({
  selector: 'app-activity-summary-block',
  templateUrl: './activity-summary-block.component.html',
})
export class ActivitySummaryBlockComponent {
  @Input() categories: ActivitySummaryCategory[] = [];
}
